import Vue from 'vue'

// State
const state = {
  isLoading: false,
  data: null
}

// Mutations
const fetchStatusRequest = 'fetchStatusRequest'
const fetchStatusResponse = 'fetchStatusResponse'

const mutations = {
  [fetchStatusRequest] (state) {
    state.isLoading = true
  },
  [fetchStatusResponse] (state, status) {
    state.isLoading = false
    state.data = status
  }
}

// Actions
export const fetchStatus = 'fetchStatus'

const actions = {
  [fetchStatus]: ({ commit, dispatch }) => {
    commit(fetchStatusRequest)
    return Vue.http.get(`${SERVER_URL}/status`).then(({ data: status }) => {
      commit(fetchStatusResponse, status)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js